import { useState, useRef, useEffect } from 'react';
import Button from './Button';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import ItemPanel from './ItemPanel';

const Header = ({ showSecondaryButton = false }) => {
	const { t } = useTranslation();
	const [isOpen, setIsOpen] = useState(false);
	const userPanelRef = useRef(null);
	const { user, logout } = useAuth();
	const navigate = useNavigate();

	const menuItems = [
		{
			label: 'general.change_password',
			url: '/auth/change-password',
		},
		{
			label: 'general.logout',
			icon: 'ri-logout-box-line',
			textClass: 'text-outline',
			onClick: logout,
		},
	];

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (userPanelRef.current && !userPanelRef.current.contains(event.target)) {
				setIsOpen(false);
			}
		};

		if (isOpen) {
			document.addEventListener('mousedown', handleClickOutside);
		}

		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [isOpen]);

	return (
		<div className='flex justify-between items-center border-b border-tertiary px-8 py-2.5 bg-white'>
			<NavLink to='/' className='flex items-center gap-1.5'>
				<div>
					<img src='/images/Socrates_ikon.png' alt='Socrates illustration' className='max-h-10' />
				</div>
				<span className='text-lg font-bree-serif text-outline'>{t('general.app_name')}</span>
				<div className='bg-secondary text-base font-bree-serif text-outline rounded-xs py-1 px-[5px] leading-none'>
					Ai
				</div>
			</NavLink>

			<div className='flex items-center gap-6'>
				<div className='relative flex items-center gap-2' ref={userPanelRef}>
					<button
						className='flex items-center focus:outline-none focus-visible:ring-primary focus-visible:ring-2 ring-offset-2 rounded-sm gap-2 cursor-pointer'
						onClick={() => setIsOpen(!isOpen)}
					>
						<i className='ri-user-line bg-tertiary rounded-full p-[0.5px] px-1' />
						<span
							className={`font-medium select-none text-primary-text ${
								isOpen ? 'underline decoration-0' : ''
							}`}
						>
							{user?.name}
						</span>
						<i
							className={`cursor-pointer text-xl ${
								isOpen ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'
							}`}
							aria-label='Toggle user panel'
						/>
					</button>

					{isOpen && <ItemPanel items={menuItems} positionClass='top-13 right-0 w-full' />}
				</div>

				<div className='flex gap-2'>
					<Button size='medium' type='line' onClick={() => navigate('/guide')}>
						{t('header.help_button')}
					</Button>

					{showSecondaryButton && (
						<Button size='medium' type='solid' onClick={() => navigate('/')}>
							{t('header.create_button')}
						</Button>
					)}
				</div>
			</div>
		</div>
	);
};

Header.propTypes = {
	showSecondaryButton: PropTypes.bool,
};

export default Header;
